export const FLOOR_LOADED = "FLOOR_LOADED";
export const FLOOR_SAVED = "FLOOR_SAVED";
export const SET_LOAD_SAVE_CALLBACKS = "SET_LOAD_SAVE_CALLBACKS";
